<section class="dashboard">
    <div class="dashboard-lead-card">
        <div class="dashboard-lead-card-header">
            <span class="icon dashboard-lead-card-header-icon-box" svgIcon="assets/svg/icons/user-gb.svg"></span>
            <h3 class="dashboard-lead-card-header-title">
                {{
                    stage === "PROFILE_PENDING"
                        ? "The earlier profile photo is outdated. Please update it to continue"
                        : "Your profile picture is being verified. We’ll notify you once it’s done."
                }}
            </h3>
        </div>
        <div class="dashboard-lead-card-body">
            <div class="dashboard-lead-card-body-content">
                <button
                    type="button"
                    *ngIf="stage === 'PROFILE_PENDING'"
                    class="primary-gradient-btn btn-w100 apply-btn"
                    (click)="reTakePicture()"
                >
                    Update Profile Photo
                    <img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                </button>
                <button
                    *ngIf="stage !== 'PROFILE_PENDING'"
                    type="button"
                    class="primary-fill-btn btn-w100 apply-btn"
                    [routerLink]="['/support']"
                >
                    Contact Support
                </button>
            </div>
        </div>
    </div>
</section>
